import {get} from "../../https/index";

const ManuFacturerApi = {
    point: (params) => get("/resource/manufacturer/statistic/point", params),
    pointdetail: (refId) => get(`/resource/manufacturer/statistic/point/detail/${refId}`),
    faultdetail: (id, params) => get(`/resource/manufacturer/statistic/point/fault/detail/${id}`, params),
    types: (params) => get(`/resource/device/types`, params),
    manufacturers: (params) => get(`/resource/manufacturers/page`, params),
}
export default ManuFacturerApi;